// extracted by mini-css-extract-plugin
module.exports = {"container":"myProjects__container___Unl70","projects":"myProjects__projects___j6W1f","card--project":"myProjects__card--project___U98fl"};